// extracted by mini-css-extract-plugin
export default {"blockUiContainer":"blockUi_blockUiContainer__vMzze","blockUiMessageContainer":"blockUi_blockUiMessageContainer__DzHsa"};